<script>
    import router from 'page'

    import NewNotebook from './routes/NewNotebook.svelte'
    import NotebookPage from './routes/NotebookPage.svelte'
    import EntryEdit from './routes/EntryEdit.svelte'
    import ImportExport from './routes/ImportExport.svelte'

    import Index from './routes/Index.svelte'
    import About from './routes/About.svelte'
    import Screen from './routes/Screen.svelte'
    import Link from './routes/Link.svelte'

    let content_page
    let params
    router('/',
        (ctx, next) => {params = ctx.params; next()},
        (ctx) => content_page = Index)
    router('/about/',
        (ctx, next) => {params = ctx.params; next()},
        (ctx) => content_page = About)
    router('/screen/',
        (ctx, next) => {params = ctx.params; next()},
        (ctx) => content_page = Screen)
    router('/import_export',
        (ctx, next) => {params = ctx.params; next()},
        (ctx) => content_page = ImportExport)
    router('/new_notebook',
        (ctx, next) => {params = ctx.params; next()},
        (ctx) => content_page = NewNotebook)
    router('/notebook/:id',
        (ctx, next) => {params = ctx.params; next()},
        (ctx) => content_page = NotebookPage)
    router('/notebook/:notebook_id/new_entry',
        (ctx, next) => {params = ctx.params; next()},
        (ctx) => content_page = EntryEdit)
    router('/notebook/:id/:selected_entry_id',
        (ctx, next) => {params = ctx.params; next()},
        (ctx) => content_page = NotebookPage)
    router('/notebook/:notebook_id/:entry_id/edit',
        (ctx, next) => {params = ctx.params; next()},
        (ctx) => content_page = EntryEdit)

    router.start()

</script>


<main>
    <svelte:component this={content_page} {...params}/>
</main>


<style>
	main {
		text-align: center;
		margin: 0 auto;
        width: 100%;
        height: 100%;
	}
    :global(a), :global(a:visited) {
        color: rgb(108, 189, 255);
    }
    :global(body) {
        background-color: #181a1b;
        color: white;
    }
</style>
